/* eslint-disable no-console */
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

import {
	FIREBASE_API_KEY,
	FIREBASE_APP_ID,
	FIREBASE_AUTH_DOMAIN,
	FIREBASE_MESSAGING_SENDER_ID,
	FIREBASE_PROJECT_ID,
	FIREBASE_STORAGE_BUCKET,
	VAPID_KEY,
} from '../constant/api.ts';

export const FIREBASE_CONFIG = initializeApp({
	apiKey: FIREBASE_API_KEY,
	authDomain: FIREBASE_AUTH_DOMAIN,
	projectId: FIREBASE_PROJECT_ID,
	storageBucket: FIREBASE_STORAGE_BUCKET,
	messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
	appId: FIREBASE_APP_ID,
});
export const PUBLIC_KEY = VAPID_KEY;

if ('serviceWorker' in navigator) {
	window.addEventListener('load', function () {
		navigator.serviceWorker
			.register('/service-worker.js')
			.then(async (registration) => {
				console.log(`ServiceWorker registration successful with scope: ${registration.scope}`);

				return registration.update();
			})
			.then(() => console.log(`ServiceWorker updated`))
			.catch((err) => console.log('ServiceWorker registration failed: ', err));
	});
}

export const registrationFirebaseToken = async () => {
	await navigator.serviceWorker.getRegistration().then(
		async (registration) =>
			await getToken(getMessaging(FIREBASE_CONFIG), {
				vapidKey: PUBLIC_KEY,
				serviceWorkerRegistration: registration,
			})
				.then((firebaseToken) => {
					console.log(`firebaseToken: ${firebaseToken}`);
					localStorage.setItem('notify', firebaseToken);
				})
				.catch((e) => console.log(e)),
	);
};

export const getPermission = () => {
	return new Promise(function (resolve, reject) {
		const permissionResult = Notification.requestPermission(function (result) {
			// Поддержка устаревшей версии с функцией обратного вызова.
			resolve(result);
		});

		if (permissionResult) {
			permissionResult.then(resolve, reject);
		}
	}).then(async (permissionResult) => {
		console.log(permissionResult);
		if (permissionResult === 'granted') {
			await registrationFirebaseToken();
			console.log('Notification permission is active.');
		} else if (permissionResult === 'denied') {
			console.error('Notification permission not granted.');
		}

		return permissionResult;
	});
};
